export default __webpack_public_path__ + "static/media/grubhub.f16753ab.svg";